export default __webpack_public_path__ + "static/media/sanangel-hosp.919d4ae4.png";